import React, { useCallback } from 'react';
import Animated from 'react-native-reanimated';
import { View } from 'react-native';
import { AppView, CardView, CollapsableContainer, Spacer, rem, withAnimatedNavigationHeader, } from 'design-system';
import useAppFrameDimensions from 'hooks/useAppFrameDimensions';
import { useMarginBottom } from 'hooks/useMarginBottom';
import Button, { HEIGHT_PLUS_PADDING } from 'design-system/Button';
import Text from 'design-system/Text';
import links from 'utils/links';
import Logo from 'design-system/Logo';
import createStyleSheets from 'utils/createStyleSheets';
import useStyles from 'hooks/useStyles';
import { isWeb } from '../../../../constants';
const CurrentAccountSwitchOffer = withAnimatedNavigationHeader(({ route, scrollHandler }) => {
    const { image, title, subtitle, benefits, description, about, terms, link, } = route.params;
    const styles = useStyles(styleSet);
    const onGetOffer = useCallback(() => links.openLink(link), [link]);
    const { paddingHorizontalStyle } = useAppFrameDimensions(isWeb);
    const contentContainerStyle = useMarginBottom('paddingBottom', HEIGHT_PLUS_PADDING, paddingHorizontalStyle, styles.contentContainer);
    return (<AppView withFrame={false}>
          <Animated.ScrollView onScroll={scrollHandler} scrollEventThrottle={16} contentContainerStyle={contentContainerStyle}>
            <View style={styles.logoContainer}>
              <Logo uri={image} R64 resizeMode="contain"/>
              <Spacer.H16 />
              <Text Text-18>{title}</Text>
              <Text TextThin-14 Secondary centered>
                {subtitle}
              </Text>
            </View>
            <CardView style={styles.benefitsContainer} withPadding noMargin>
              {benefits.map((benefit, index) => (<View key={benefit.title} style={[
                styles.benefitItem,
                index !== benefits.length - 1 &&
                    styles.benefitItemSeparator,
            ]}>
                  <Text Numbers-16 centered>
                    {benefit.title}
                  </Text>
                  <Text TextThin-12 Secondary centered>
                    {benefit.subtitle}
                  </Text>
                </View>))}
            </CardView>

            <Spacer.H16 />
            <CollapsableContainer title="Description" isCollapsedByDefault={false} style={styles.collapsible}>
              <Text TextThin-14 Secondary>
                {description}
              </Text>
            </CollapsableContainer>
            <Spacer.H16 />
            <CollapsableContainer title="About" isCollapsedByDefault style={styles.collapsible}>
              <Text TextThin-14 Secondary>
                {about}
              </Text>
            </CollapsableContainer>
            <Spacer.H16 />
            <CollapsableContainer title="T&Cs" isCollapsedByDefault style={styles.collapsible}>
              <Text TextThin-14 Secondary>
                {terms}
              </Text>
            </CollapsableContainer>
          </Animated.ScrollView>

          <Button floating brand title="Go to website" onPress={onGetOffer}/>
        </AppView>);
}, ({ colors, route }) => ({
    title: route.params.title,
    headerColorOutputRange: [
        colors.background.dark,
        colors.cards.onDark,
    ],
}));
const styleSet = createStyleSheets((colors) => ({
    contentContainer: {
        marginHorizontal: rem(16),
    },
    logoContainer: {
        alignItems: 'center',
        marginTop: rem(16),
        marginBottom: rem(24),
    },
    collapsible: {
        padding: rem(16),
    },
    benefitsContainer: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
    },
    benefitItem: {
        flex: 1,
        alignItems: 'center',
    },
    benefitItemSeparator: {
        height: '100%',
        borderRightWidth: 1,
        borderRightColor: colors.borders.divider,
    },
}));
export default CurrentAccountSwitchOffer;
